<template>
  <el-card
    shadow="nerver"
    class="box-card"
  >
    <div class="finance-info">
      <el-row>
        <el-col :span="8">
          <span>手机号码：</span>
        </el-col>
        <el-col :span="16">
          <span>{{financeModel.phone}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <span>积分：</span>
        </el-col>
        <el-col :span="16">
          <span>{{financeModel.bonusPoint - dataModel.oldBonusPointCost}}({{dataModel.totalBonusPointAmount | toCurrency}})</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <span>余额：</span>
        </el-col>
        <el-col :span="16">
          <span>{{financeModel.balance - dataModel.oldBalanceCost | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <span>现金减：</span>
        </el-col>
        <el-col :span="16">
          <span>{{financeModel.cashDecreasedAmount - dataModel.oldCashDecreasedAmount | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <span>欠款：</span>
        </el-col>
        <el-col :span="16">
          <span>{{financeModel.balanceDue | toCurrency}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row v-if="optionModel.enableEdit">
      <el-col :span="20">
        <el-form
          ref="balanceCost"
          :model="dataModel"
          :rules="bcRules"
          label-width="100px"
          label-position="right"
        >

          <el-form-item
            label="使用余额："
            prop="balanceCost"
          >
            <el-input
              placeholder="请输入余额数值"
              v-model="dataModel.balanceCost"
              class="input-width"
            >
              <el-button
                slot="append"
                size="small"
                type="primary"
                @click="onUseBalanceClick"
              >确定</el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-form
          ref="bonusPointCost"
          :model="dataModel"
          :rules="bpcRules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item
            label="使用积分："
            prop="bonusPointCost"
          >
            <el-input
              placeholder="请输入积分数值"
              v-model="dataModel.bonusPointCost"
              class="input-width"
            >
              <el-button
                slot="append"
                size="small"
                type="primary"
                @click="onUseBonusPointClick"
              >确定</el-button>
            </el-input>
          </el-form-item>
        </el-form>
         <el-form
          ref="cashDecreasedAmount"
          :model="dataModel"
          :rules="cashDecreasedAmountRules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item
            label="使用现金减："
            prop="cashDecreasedAmount"
          >
            <el-input
              placeholder="请输入现金减数值"
              v-model="dataModel.cashDecreasedAmount"
              class="input-width"
            >
              <el-button
                slot="append"
                size="small"
                type="primary"
                @click="onCashDecreasedAmountClick"
              >确定</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>

<style lang="scss" scoped>
.box-card {
  background-color: #f5f7fa;

  .finance-info {
    padding: 0px 0px 20px 20px;
  }
}
</style>

<script>
export default {
  props: {
    options: {
      enableEdit: Boolean
    },
    data: {
      bonusPointMechanisms: {
        bonusPointToMoneyRate: Number
      },
      discounts: Array,
      studentId: Number,
      phone: String,
      bonusPoint: Number,
      balance: Number,
      balanceDue: Number,
      paymentAmount: Number,
      oldBalanceCost: Number,
      oldBonusPointCost: Number,
      oldBonusPointPrice: Number,
      cashDecreasedAmount: Number,
      oldCashDecreasedAmount: Number
    }
  },
  data() {
    let self = this;

    let validateBalanceCost = (rule, value, callback) => {
      if (!value || value == 0) {
        callback();
        return;
      }

      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!isValid) {
        callback(new Error("请输入正确的余额数值"));
        return;
      }

      if (!message && value > self.financeModel.balance) {
        callback(new Error("余额数值不能大于可用余额"));
        return;
      }

      let message = "";
      let balanceCostNumber = parseFloat(value);
      if (isNaN(balanceCostNumber)) balanceCostNumber = 0;
      if (
        balanceCostNumber >
        self.dataModel.paymentAmount + self.dataModel.oldBalanceCost
      ) {
        message = "余额数值不能大于应付价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBonusPointCost = (rule, value, callback) => {
      if (!value || value == 0) {
        self.dataModel.bonusPointPrice = 0;
        callback();
        return;
      }

      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!isValid) {
        callback(new Error("请输入正确的积分数值"));
        return;
      }

      if (value > self.financeModel.bonusPoint) {
        callback(new Error("积分数值不能大于可用积分"));
        return;
      }

      let bonusPointCostNumber = parseFloat(value);
      if (isNaN(bonusPointCostNumber)) bonusPointCostNumber = 0;
      if (!self.financeModel.studentId || !bonusPointCostNumber) {
        self.dataModel.bonusPointPrice = 0;
        callback();
        return;
      }

      let message = "";
      self.calculateBPAmount(bonusPointCostNumber);
      if (
        self.dataModel.bonusPointPrice >
        self.dataModel.paymentAmount + self.dataModel.oldBonusPointPrice
      ) {
        message = `积分抵扣(${
          self.dataModel.bonusPointPrice
        })不能大于应付价格`;
      }

      if (!!message) callback(new Error(message));
      else callback();
    };

    let validateCashDecreasedAmount = (rule, value, callback) => {
      if (!value || value == 0) {
        self.dataModel.cashDecreasedAmount = 0;
        callback();
        return;
      }

      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!isValid) {
        callback(new Error("请输入正确的数值"));
        return;
      }

      let message = "";
      if (self.dataModel.cashDecreasedAmount > self.dataModel.paymentAmount + self.dataModel.oldCashDecreasedAmount) {
        message = `现金减(${
          self.dataModel.cashDecreasedAmount
        })不能大于应付价格(${self.dataModel.paymentAmount + self.dataModel.oldCashDecreasedAmount})`;
      }

      if (!!message) callback(new Error(message));
      else callback();
    };

    return {
      submitBtnDisableBC: false,
      submitBtnDisableBPC: false,
      submitBtnDisableCashDecreasedAmount: false,
      bonusPointMechanisms: {
        bonusPointToMoneyRate: 0
      },
      discounts: [],
      financeModel: {
        studentId: 0,
        phone: null,
        bonusPoint: 0,
        balance: 0,
        balanceDue: 0
      },
      optionModel: {
        enableEdit: false
      },
      dataModel: {
        balanceCost: "",
        bonusPointCost: "",
        totalBonusPointAmount: 0,
        bonusPointPrice: 0,
        paymentAmount: 0,
        oldBalanceCost: 0,
        oldBonusPointCost: 0,
        oldBonusPointPrice: 0,
        cashDecreasedAmount: 0,
        oldCashDecreasedAmount: 0
      },
      bcRules: {
        balanceCost: [
          {
            validator: validateBalanceCost,
            trigger: "change"
          }
        ]
      },
      bpcRules: {
        bonusPointCost: [
          {
            validator: validateBonusPointCost,
            trigger: "change"
          }
        ]
      },
      cashDecreasedAmountRules: {
        cashDecreasedAmount: [
          {
            validator: validateCashDecreasedAmount,
            trigger: "change"
          }
        ]
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionsFromProps();
    this.initData();
  },
  updated() {},
  methods: {
    loadOptionsFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.enableEdit = options.enableEdit;
      } else {
        this.optionModel.enableEdit = false;
      }
    },
    loadDataFromProps(data = this.data) {
      if (!!data) {
        this.bonusPointMechanisms.bonusPointToMoneyRate = !!data.bonusPointMechanisms
          ? data.bonusPointMechanisms.bonusPointToMoneyRate
          : 0;
        this.discounts = data.discounts;
        this.financeModel.studentId = data.studentId;
        this.financeModel.phone = data.phone;
        this.financeModel.bonusPoint = data.bonusPoint;
        this.financeModel.balance = data.balance;
        this.financeModel.balanceDue = data.balanceDue;
        this.dataModel.paymentAmount = data.paymentAmount;
        this.dataModel.oldBalanceCost = data.oldBalanceCost;
        this.dataModel.oldBonusPointCost = data.oldBonusPointCost;
        this.dataModel.oldBonusPointPrice = data.oldBonusPointPrice;
        this.dataModel.cashDecreasedAmount = data.cashDecreasedAmount;
        this.dataModel.oldCashDecreasedAmount = data.oldCashDecreasedAmount;
      } else {
        this.bonusPointMechanisms.bonusPointToMoneyRate = 0;
        this.discounts = [];
        this.financeModel.studentId = 0;
        this.financeModel.phone = null;
        this.financeModel.bonusPoint = 0;
        this.financeModel.balance = 0;
        this.financeModel.balanceDue = 0;
        this.dataModel.paymentAmount = 0;
        this.dataModel.oldBalanceCost = 0;
        this.dataModel.oldBonusPointCost = 0;
        this.dataModel.oldBonusPointPrice = 0;
        this.dataModel.cashDecreasedAmount = 0;
        this.dataModel.oldCashDecreasedAmount = 0;
      }
    },
    checkBCInputs(onlyCheck) {
      let isValidBC = true;

      let $refBC = this.$refs["balanceCost"];
      if (!!$refBC) {
        $refBC.validate(valid => {
          if (!valid) {
            isValidBC = false;
            return;
          }
        });
      }

      if (!onlyCheck) {
        this.submitBtnDisableBC = !isValidBC;
      }

      return isValidBC;
    },
    checkBPCInputs(onlyCheck) {
      let isValidBPC = true;

      let $refBPC = this.$refs["bonusPointCost"];
      if (!!$refBPC) {
        $refBPC.validate(valid => {
          if (!valid) {
            isValidBPC = false;
          }
        });
      }

      if (!onlyCheck) {
        this.submitBtnDisableBPC = !isValidBPC;
      }

      return isValidBPC;
    },
    checkCashDecreasedAmountInputs(onlyCheck) {
      let isValid = true;

      let $refCashDecreasedAmount = this.$refs["cashDecreasedAmount"];
      if (!!$refCashDecreasedAmount) {
        $refCashDecreasedAmount.validate(valid => {
          if (!valid) {
            isValid = false;
          }
        });
      }

      if (!onlyCheck) {
        this.submitBtnDisableCashDecreasedAmount = !isValid;
      }
      

      return isValid;
    },
    initData(data = this.data) {
      this.loadDataFromProps(data);
      this.calculateTotalBPAmount(
        this.financeModel.bonusPoint - this.dataModel.oldBonusPointCost
      );
      this.checkBCInputs();
      this.checkBPCInputs();
    },
    calculateTotalBPAmount(currentBonusPoint) {
      if (!this.financeModel.studentId || !currentBonusPoint) {
        this.dataModel.totalBonusPointAmount = 0;
        return;
      }

      this.dataModel.totalBonusPointAmount =
        currentBonusPoint * this.bonusPointMechanisms.bonusPointToMoneyRate;
    },
    calculateBPAmount(bonusPointCost) {
      if (!this.financeModel.studentId || !bonusPointCost) {
        this.dataModel.bonusPointPrice = 0;
        return;
      }

      this.dataModel.bonusPointPrice =
        bonusPointCost * this.bonusPointMechanisms.bonusPointToMoneyRate;
    },
    onUseBalanceClick() {
      let isValid = this.checkBCInputs();
      if (!isValid) return;

      let balanceCostNumber = parseFloat(this.dataModel.balanceCost);
      if (isNaN(balanceCostNumber)) balanceCostNumber = 0;

      if (balanceCostNumber == this.dataModel.oldBalanceCost) return;

      this.$emit("callback", {
        success: !this.submitBtnDisableBC,
        data: {
          type: 1,
          balanceCost: balanceCostNumber
        }
      });
    },
    onUseBonusPointClick() {
      this.submitBtnDisableBPC = true;
      let isValid = this.checkBPCInputs();
      if (!isValid) return;

      let bonusPointCostNumber = parseFloat(this.dataModel.bonusPointCost);
      if (isNaN(bonusPointCostNumber)) bonusPointCostNumber = 0;

      if (bonusPointCostNumber == this.dataModel.oldBonusPointCost) return;

      this.$emit("callback", {
        success: !this.submitBtnDisableBPC,
        data: {
          type: 2,
          bonusPointCost: bonusPointCostNumber,
          bonusPointPrice: this.dataModel.bonusPointPrice
        }
      });
    },
    onCashDecreasedAmountClick() {
      this.submitBtnDisableCashDecreasedAmount = true;
      let isValid = this.checkCashDecreasedAmountInputs();
      if (!isValid) return;
     
      let cashDecreasedAmount = parseFloat(this.dataModel.cashDecreasedAmount);
      if (isNaN(cashDecreasedAmount)) cashDecreasedAmount = 0;

      if (cashDecreasedAmount == this.dataModel.oldCashDecreasedAmount) return;

      this.$emit("callback", {
        success: !this.submitBtnDisableCashDecreasedAmount,
        data: {
          type: 3,
          cashDecreasedAmount: cashDecreasedAmount
        }
      });
    },
    __getFormulaResultValue(name, resultData) {
      let value = 0;
      let obj = resultData.filter(i => i.Name == name);
      if (!!obj && obj.length > 0) {
        value = obj[0].Value;
      }
      return value;
    }
  },
  watch: {
    options: function(newVal) {
      this.loadOptionsFromProps(newVal);
    },
    data: function(newVal) {
      this.initData(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/useFinanceEditor.vue